export default "/shell.1a6bce620d84e407ce933c422ede0641.svg";